import { Record } from 'immutable';

import { StateRecord } from '@mode/shared/contract-common';

export interface ReportDatasetColumn {
  name: string;
  type: string;
}

export interface ReportDatasetRecord extends StateRecord {
  isLoaded: boolean;
  columns: ReportDatasetColumn[];
  content: object[];
  count: number;
  bytes: number;
  state: string;
  queryName: string;
  query_token: string;
  reportDataUrl: string;
  reportQueryUrl: string;
  content_length: number;
  oversized: boolean;
  csv: string;
}

const DefaultReportDatasetRecord: ReportDatasetRecord = {
  id: null,
  token: '',
  isLoaded: false,
  content: [],
  columns: [],
  count: 0,
  bytes: 0,
  state: 'succeeded',
  queryName: null,
  reportDataUrl: null,
  reportQueryUrl: null,
  query_token: null,
  content_length: 0,
  oversized: false,
  csv: null,
};

export class ReportDataset
  extends Record<ReportDatasetRecord>(DefaultReportDatasetRecord)
  implements ReportDatasetRecord
{
  constructor(params?: Partial<ReportDatasetRecord>) {
    params ? super(params) : super();
  }

  // set queryName(name: string) {
  //   this.set('queryName', name);
  // }

  with(values: Partial<ReportDatasetRecord>): ReportDataset {
    return this.merge(values);
  }
}

export function datasetsAndQueryNameByToken(datasetsByToken, orderedQueries) {
  return orderedQueries
    .filter((q) => !!datasetsByToken[q.token])
    .map((query) =>
      datasetsByToken[query.token]
        .with({
          queryName: query.name || 'Query',
        })
        .toJSON()
    );
}
